import { c as _c } from "react/compiler-runtime";
import { Stack, type SxProps, type Theme } from '@mui/material';
import classnames from 'classnames';
import { useScrollable } from './useScrollable';
export const ScrollableContent = t0 => {
  const $ = _c(16);
  const {
    children,
    className,
    sx,
    "data-testid": dataTestId
  } = t0;
  const {
    isScrolledVertically,
    setIsScrolledVertically
  } = useScrollable();
  let t1;
  if ($[0] !== className) {
    t1 = classnames("overflow-auto", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== isScrolledVertically || $[3] !== setIsScrolledVertically) {
    t2 = event => {
      const target = event.target as HTMLDivElement;
      if (typeof target.scrollTop === "number") {
        const isScrolled = target.scrollTop > 0;
        if (isScrolled !== isScrolledVertically) {
          setIsScrolledVertically(isScrolled);
        }
      }
    };
    $[2] = isScrolledVertically;
    $[3] = setIsScrolledVertically;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      flexGrow: 1
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== sx) {
    t4 = Array.isArray(sx) ? sx : [sx ?? false];
    $[6] = sx;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = [t3, ...t4];
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== children || $[11] !== dataTestId || $[12] !== t1 || $[13] !== t2 || $[14] !== t5) {
    t6 = <Stack className={t1} data-testid={dataTestId} onScroll={t2} sx={t5}>{children}</Stack>;
    $[10] = children;
    $[11] = dataTestId;
    $[12] = t1;
    $[13] = t2;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
};